"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import styles from "./page.module.css";

export default function Home() {
  const [practiceCount, setPracticeCount] = useState<number | null>(null);

  const basePath = process.env.NEXT_PUBLIC_BASE_PATH || "";

  useEffect(() => {
    fetch(`${basePath}/api/good-practices?status=published`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setPracticeCount(data.length);
        }
      })
      .catch((err) => console.error("Error fetching practices:", err));
  }, []);

  return (
    <div className={styles.page}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className="container">
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              DESCUBRE EL PODER DE LAS <span className={styles.highlight}>BUENAS PRÁCTICAS DE INNOVACIÓN</span> EN PRIMERA LÍNEA
            </h1>
            <p className={styles.heroSubtitle}>
              Frontline Innovative Practices Bank - <span className={styles.highlight}>FIP BANK</span>
            </p>

            <div className={styles.heroCta}>
              <Link href="/what-is" className="btn btn-primary">
                ¿Qué es FIP Bank?
              </Link>
              <Link href="/good-practices" className="btn btn-outline">
                Explorar Prácticas
              </Link>
              
              {/* Stats Counter */}
              {practiceCount !== null && (
                <div className={styles.statsCounter}>
                  <div className={styles.statItem}>
                    <span className={styles.statNumber}>{practiceCount}</span>
                    <span className={styles.statLabel}>Prácticas Publicadas</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Logos Section */}
      <section className={styles.logosSection}>
        <div className="container">
          <div className={styles.logosGrid}>
            <img src={`${basePath}/assets/logos/una4career.svg`} alt="UNA4CAREER" className={styles.logo} />
            <img src={`${basePath}/assets/logos/ue.svg`} alt="Unión Europea" className={styles.logo} />
            <img src={`${basePath}/assets/logos/ucm.svg`} alt="Universidad Complutense de Madrid" className={styles.logo} />
            <img src={`${basePath}/assets/logos/madrid.svg`} alt="Comunidad de Madrid" className={styles.logo} />
            <img src={`${basePath}/assets/logos/itc.svg`} alt="ITC" className={styles.logo} />
          </div>
        </div>
      </section>

      {/* Project Info Section */}
      <section className="section">
        <div className="container">
          <div className={styles.projectInfo}>
            <div className={styles.infoBox}>
              <h2>Sobre el Proyecto</h2>
              <p>
                <strong>UNA4CAREER</strong> - UNA Europa, an alliance of universities FOR the emergence of talent and the development of research CAREERs
              </p>
              <p className={styles.grantInfo}>
                H2020-MSCA-COFUND-2018 - UNA4CAREER - GA No 847635<br />
                Call: H2020-MSCA-COFUND-2018-UNA4CAREER-2
              </p>
            </div>

            <div className={styles.teamSection}>
              <div className={styles.teamBlock}>
                <h3>Responsables</h3>
                <ul>
                  <li>
                    Dra. Melisa Campana Alabarce
                    <a href="https://orcid.org/0000-0003-3988-8273" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>
                    Dr. Andrés Arias Astray
                    <a href="https://orcid.org/0000-0001-8614-0714" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>
                    Dr. Juan Pavón Mestras
                    <a href="https://orcid.org/0000-0002-9553-8123" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                </ul>
              </div>

              <div className={styles.teamBlock}>
                <h3>Colaboradoras/es</h3>
                <ul>
                  <li>
                    Dr. Martín H. Di Marco
                    <a href="https://orcid.org/0000-0002-0568-0581" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>
                    Dr. Juan Librandi
                    <a href="https://orcid.org/0000-0001-8771-4898" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>
                    Dra. Micaela Díaz Rosaenz
                    <a href="https://orcid.org/0000-0002-1064-4980" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>
                    Mg. María Clara Mariné
                    <a href="https://orcid.org/0009-0004-4690-3552" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>Ing. María Candela Infante</li>
                  <li>
                    Dr. Sergio D'Antonio Maceiras
                    <a href="https://orcid.org/0000-0001-8320-0902" target="_blank" rel="noopener noreferrer" className={styles.orcidLink}>
                      <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD" className={styles.orcidIcon} />
                    </a>
                  </li>
                  <li>Dirección General de Servicios Sociales y Atención a la Discapacidad del Ayuntamiento de Madrid</li>
                  <li>Profesionales de los Servicios Sociales de Los Distritos de la Ciudad de Madrid</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
